import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import M from 'materialize-css';
import _ from 'lodash';

import Footer from '../../lib/layout/Footer';
import LogoutButton from '../User/LogoutButton';
import Breadcrumbs from './Breadcrumbs';

import { selectUser } from '../../lib/userSlice';
import { useGetSystemQuery } from '../../lib/ascertis-api';

const classNames = require('classnames');
const moment = require('moment');

const AuthDefaultLayout = ({ children }) => {
  const user = useSelector(selectUser);
  // Note that the systemId is not always available if we're not on a system-specific page
  const { systemId } = useParams();
  const wrapperClasses = classNames({
    'app-container': true,
    'without-sidebar': true
  });

  const { data: system } = useGetSystemQuery({ systemId }, { skip: _.isEmpty(systemId) });

  const headerClasses = classNames({
    navbar: true,
    'nav-extended': true
  });

  let extraHeaderContent = null;
  if (system && system.status === 'trial') {
    const formattedEndDate = moment(system.trialEndsAt).format('YYYY-MM-DD');
    const message = `This is a trial instance, which will expire on ${formattedEndDate}. Please contact ASCERTIS at support@ascertis.solutions to upgrade to a paid version to continue access to this instance past that date.`;
    extraHeaderContent = (
      <div className="trial-notification">
        {message}
      </div>
    );
  }

  const loadDropdownJs = () => {
    const options = {};
    const elems = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elems, options);
  };

  useEffect(() => {
    loadDropdownJs();
  }, []);

  let solutionPartnerLink = undefined;
  const isSuperAdmin = user.superAdmin;
  if (isSuperAdmin) {
    solutionPartnerLink = (
      <li className="header-nav-item">
        <Link to="/solution_partners" className="solution-partners-link" id="solution-partners-header-link">Solution Partners</Link>
      </li>
    );
  }

  return (
    <div className={wrapperClasses}>
      <header>
        <ul id="account-dropdown" className="dropdown-content">
          <li><Link to="/account/edit">Update Account</Link></li>
          <li className="divider"></li>
          <li><LogoutButton /></li>
        </ul>

        <nav className={headerClasses}>
          <div className="nav-wrapper">
            <Link to="/" className="brand-logo">ASCERTIS</Link>
            <ul className="right header-nav-items">
              {solutionPartnerLink}
              <li className="header-nav-item">
                <a href="https://cmmcworkshop.com/welcome-to-the-cmmc-workshop/" target="_blank">
                  CMMC Workshop<i className="material-icons right">speaker_notes</i>
                </a>
              </li>
              <li className="header-nav-item">
                <a className="dropdown-trigger" href="#" data-target="account-dropdown">
                  Account / Logout<i className="material-icons right">arrow_drop_down</i>
                </a>
              </li>
            </ul>
          </div>
          <div className="nav-content">
            {extraHeaderContent}
          </div>
        </nav>
      </header>
      <Breadcrumbs />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

AuthDefaultLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

AuthDefaultLayout.defaultProps = {
  children: null
};

export default AuthDefaultLayout;
